import { FC } from 'react'
import { Box, Stack, Typography, useTheme } from '@mui/material'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';


export const CautionCard:FC = () => {
  const theme = useTheme()

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.yellow[50],
        p: 2,
        borderRadius: 2,
        color: theme.palette.green[800],
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" mb={1}>
        <ErrorOutlineIcon sx={{ color: theme.palette.yellow[800], fontSize: '1.3rem' }} />
        <Typography fontWeight={theme.typography.fontWeightBold} fontSize="1rem" mb={1}>
          Caution
        </Typography>
      </Stack>

      <Typography fontWeight={theme.typography.fontWeightMedium} fontSize="0.9rem">
        Your reading is safe, but is on the verge of becoming unsafe. It's recommended to monitor this
      </Typography>
    </Box>
  )
}